import PropTypes from 'prop-types';
import { twMerge } from 'tailwind-merge';

const TYPES = {
  primary:
    'bg-primary-100 border-primary-300 active:bg-primary-200 hover:bg-primary-200 hover:ring-primary-400',
  secondary:
    'bg-secondary-100 border-secondary-300 active:bg-secondary-200 hover:bg-secondary-200 hover:ring-secondary-400',
  highlight:
    'bg-highlight-100 border-highlight-300 active:bg-highlight-200 hover:bg-highlight-200 hover:ring-highlight-400',
  success:
    'bg-success-100 border-success-300 active:bg-success-200 hover:bg-success-200 hover:ring-success-400',
};

const QuickComment = ({
  children,
  className,
  emojiLeft,
  type = 'primary',
  onClick,
}) => (
  <button
    className={twMerge(
      'flex h-12 min-w-fit cursor-pointer items-center justify-center gap-x-3 rounded-3 border border-solid px-2 py-2 font-sans text-sm font-bold text-neutral-low-400 transition-all hover:ring-2 active:ring-0',
      TYPES[type],
      className
    )}
    onClick={onClick}
  >
    <span>{emojiLeft}</span>
    <span>{children}</span>
  </button>
);

QuickComment.propTypes = {
  /**
   * Children to be rendered inside component
   */
  children: PropTypes.string.isRequired,
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  /**
   * Renders an emoji on the left side
   */
  emojiLeft: PropTypes.string.isRequired,
  /**
   * Renders `QuickComment` with one of the properties below
   */
  type: PropTypes.oneOf(Object.keys(TYPES)),
  /**
   * **DEVELOPMENT USE ONLY**
   *
   * Callback function on click
   */
  onClick: PropTypes.func.isRequired,
};

export default QuickComment;
